"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFlashingCellStyleViewItems = void 0;
const FlashingCellStyle_1 = require("../../../View/FlashingCell/FlashingCellStyle");
const getFlashingCellStyleViewItems = () => {
    return {
        name: 'Flash Styles',
        label: 'Change Style',
        view: FlashingCellStyle_1.FlashingCellStyle,
    };
};
exports.getFlashingCellStyleViewItems = getFlashingCellStyleViewItems;
